export const PANEL = {
  EDIT_FORM: 'EDIT_FORM',
  EDIT_FIELD: 'EDIT_FIELD',
  SETTINGS_PANEL: 'SETTINGS_PANEL',
  SUBMIT_BUTTON_SETTINGS: 'SUBMIT_BUTTON_SETTINGS'
}
